const getBuildSlug = (rootState) => rootState.ws.template.buildSlug;

export default getBuildSlug;
